/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapid_Eager_Otter_GlowInputs */

const fr_rapid_eager_otter_glow = /** @type {(inputs: Rapid_Eager_Otter_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impayé`)
};

/**

* @param {Rapid_Eager_Otter_GlowInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rapid_eager_otter_glow = /** @type {((inputs?: Rapid_Eager_Otter_GlowInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapid_Eager_Otter_GlowInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rapid_eager_otter_glow(inputs)
});